package com.bikompanion.ui.home

/** Whole seconds remaining, rounded up so a countdown never undercounts what's left. */
internal fun Long.ceilToSeconds(): Int = ((this + 999) / 1000).toInt()
